module.exports = __webpack_public_path__ + "static/GPlogogrey-654f899c884958e3e21ca5ff0246819d.png";